import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { Permissions } from '../../../system/permission';
import { MediaCenter } from './MediaCenter';
import AddPhotos from './AddPhotos';
import Photos from './Photos/index';
import AddDocuments from './AddDocuments';
import AddVirtualTour from './AddVirtualTour';
import { Typography } from '@mui/material';
import {
  ListingResource,
  useFormProgressInit,
  useListingField,
} from '@brightmls/nextgen.lae.flc';
import { PropertyField } from '../../../system/field';
import { TOTAL_STEPS } from '../background/constants';
import { useMetadata } from '../../../contexts/MetadataContext';

const PermissionRestrictionText = () => (
  <Typography
    sx={{
      fontWeight: 'bold',
      width: '100%',
      textAlign: 'center',
      my: 4,
    }}
  >
    You do not have permission to this feature.
  </Typography>
);

const ProtectedRoute = ({
  children,
  allowed,
}: {
  children: React.ReactNode;
  allowed: boolean;
}) => {
  if (!allowed) {
    return <PermissionRestrictionText />;
  }
  return <>{children}</>;
};

export const MediaRoutes = () => {
  const { allowed } = useAuth();
  const { template } = useMetadata();
  const location = useLocation();

  const isAddEditPhotosAllowed = allowed({
    permission: Permissions.UPLOAD_LISTING_PHOTOS,
  });
  const isAddEditDocumentsAllowed = allowed({
    permission: Permissions.UPLOAD_DOCUMENTS,
  });
  const isAddEditToursAllowed = allowed({
    permission: Permissions.ADD_EDIT_VIRTUAL_TOURS,
  });

  const propertyTypeField = useListingField(
    ListingResource.Property,
    PropertyField.PROPERTY_TYPE,
    'Residential',
  );

  useFormProgressInit(template(propertyTypeField.value), TOTAL_STEPS);

  // Default to photos if no media type is specified
  if (location.pathname.endsWith('/media')) {
    return <Navigate to="photos" replace />;
  }

  return (
    <Routes>
      <Route element={<MediaCenter />}>
        <Route
          path="photos"
          element={
            <ProtectedRoute allowed={isAddEditPhotosAllowed}>
              <Photos />
            </ProtectedRoute>
          }
        />
        <Route
          path="documents"
          element={
            <ProtectedRoute allowed={isAddEditDocumentsAllowed}>
              <AddDocuments />
            </ProtectedRoute>
          }
        />
        <Route
          path="tours"
          element={
            <ProtectedRoute allowed={isAddEditToursAllowed}>
              <AddVirtualTour />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};
